<template>
<ContentWrapper>
    <div class="content-heading">
      <div>서류 인증 관리</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          회원관리
        </li>
        <li class="breadcrumb-item active">
          <a href="/mem/certifiedList">서류 인증 관리</a>
        </li>
      </ol>
    </div>

<!-- 상세 -->
    <div class="card card-default book-list">
      <div class="card-body" >
        <div class="text-bold h4 mt-2">기본정보</div>
        <table class="table table-bordered table-hover" >
            <colgroup>
              <col width="12%" class="bg-lightdark"/>
              <col width="38%"/>
              <col width="12%" class="bg-lightdark"/>
              <col width="38%"/>
            </colgroup>
          <tbody>
           <tr>
               <td class="align-middle text-center bg-gray-lighter">ID</td>
               <td class="align-middle">
                 <span>{{info.data.loginId}}</span> 
               </td>
               <td class="align-middle text-center bg-gray-lighter">구분</td>
               <td class="align-middle">
                 <span>{{info.data.fileCertifyStatus == 'A' ? '정회원' : '준회원'}}</span>
               </td>
           </tr>
           <tr>
               <td class="align-middle text-center bg-gray-lighter">이름</td>
               <td class="align-middle">
                 <span>{{info.data.name}}</span>
               </td>
               <td class="align-middle text-center bg-gray-lighter">생년월일</td>
               <td class="align-middle">
                 <span>{{info.data.birthday}}</span> 
               </td>
           </tr>
           <tr>
               <td class="align-middle text-center bg-gray-lighter">회원유형</td>
               <td class="align-middle" colspan="3">
                 <span>{{userTypeName}}</span>
               </td>
           </tr>
           <tr>
               <td class="align-middle text-center bg-gray-lighter">휴대폰</td>
               <td class="align-middle">
                 <span>{{info.data.phone}}</span>
               </td>
               <td class="align-middle text-center bg-gray-lighter">이메일</td>
               <td class="align-middle">
                 <span>{{info.data.email}}</span>
               </td>
           </tr>
           <tr>
               <td class="align-middle text-center bg-gray-lighter">가입일</td>
               <td class="align-middle">
                 <span>{{info.data.regDt}}</span>
               </td>
               <td class="align-middle text-center bg-gray-lighter">회원상태</td>
               <td class="align-middle">
                 <span>{{memberStatus}}</span>
               </td>
           </tr>
           <tr>
               <td class="align-middle text-center bg-gray-lighter">최종로그인</td>
               <td class="align-middle" colspan="3">
                 <span>{{info.data.lastLoginDt}}</span>
               </td>
           </tr>
           <tr>
               <td class="align-middle text-center bg-gray-lighter">SMS 수신동의</td>
               <td class="align-middle">
                 <span>{{info.data.smsYn == 'Y' ? '동의':'미동의'}}</span>
               </td>
               <td class="align-middle text-center bg-gray-lighter">이메일 수신동의</td>
               <td class="align-middle">
                 <span>{{info.data.emailYn == 'Y' ? '동의':'미동의'}}</span>
               </td>
           </tr>
           <tr>
               <td class="align-middle text-center bg-gray-lighter">Y 클라우드 가입</td>
               <td class="align-middle">
                 <span>{{info.ext.ycloudYn === 'Y' ? '가입':'미가입'}}</span>
               </td>
               <td class="align-middle text-center bg-gray-lighter">YBM 북샘 가입</td>
               <td class="align-middle">
                   <span>{{info.ext.booksamYn === 'Y' ? '가입':'미가입'}}</span>
               </td>
           </tr>
           <tr v-if="info.data.startDt == null || info.data.endDt == null">
               <td class="align-middle text-center bg-gray-lighter">회원자격정지</td>
               <td class="align-middle" colspan="3">
                   <span>X</span>
               </td>
           </tr>
           <tr v-else-if="info.data.startDt != null && info.data.endDt != null">
               <td class="align-middle text-center bg-gray-lighter">회원자격정지</td>
               <td class="align-middle" colspan="3">
                 <span>{{info.data.startDt}} ~ {{info.data.endDt}}</span>
               </td>
           </tr>
          </tbody>
        </table>
      </div>
      <div class="card-body" style="background-color:#fff;">
        <div class="text-bold h4 mt-2">인증정보</div>
        <table class="table table-bordered table-hover">
            <colgroup>
              <col width="12%" class="bg-lightdark"/>
              <col width="38%"/>
              <col width="12%" class="bg-lightdark"/>
              <col width="38%"/>
            </colgroup>
          <tbody>
           <tr>
               <td class="align-middle text-center bg-gray-lighter">학교명</td>
               <td class="align-middle">
                 <span>{{info.data.schlNm}}</span>
               </td>
               <td class="align-middle text-center bg-gray-lighter">담임교사여부</td>
               <td class="align-middle">
                 <span>{{info.data.homeroomYn}}</span>
               </td>
           </tr>
           <tr>
               <td class="align-middle text-center bg-gray-lighter">학교주소</td>
               <td class="align-middle" colspan="3">
                 <span>{{info.data.newAddressBase}}</span>
               </td>
           </tr>
           <tr>
               <td class="align-middle text-center bg-gray-lighter">대표번호</td>
               <td class="align-middle" colspan="3">
                 <span>{{info.data.telNum}}</span>
               </td>
           </tr>
           <tr>
               <td class="align-middle text-center bg-gray-lighter">학교급</td>
               <td class="align-middle">
                 <span>{{schoolDivName}}</span>
               </td>
               <td class="align-middle text-center bg-gray-lighter">담당과목</td>
               <td class="align-middle">
                 <span>{{info.data.subjectName}}</span>
               </td>
           </tr>
           <tr>
               <td class="align-middle text-center bg-gray-lighter">교사인증유형</td>
               <td class="align-middle">
                 <span v-if="info.data.teacherPkiYn=='Y'">EPKI 인증</span>
                 <span v-else-if="info.data.teacherFileYn=='Y'">서류 인증</span>
                 <span v-else-if="info.data.fileCertifyStatus=='U'">서류 인증 대기</span>
                 <span v-else-if="info.data.fileCertifyStatus=='R'">서류 인증 거절</span>
                 <span v-else>나중에 인증하기</span>
               </td>
               <td class="align-middle text-center bg-gray-lighter">인증일시</td>
               <td class="align-middle">
                 <span>{{info.data.certifiedDt}}</span>
               </td>
           </tr>
           <tr>
               <td class="align-middle text-center bg-gray-lighter">교사인증파일</td>
               <td class="align-middle" colspan="3">
                  <span v-if="!info.data.file">파일 없음</span>
                  <span v-else-if="info.data.file === 'Deleted'">파일 삭제됨</span>
                  <span v-else-if="info.data.file.startsWith('http')">
                    <!-- <a :href="info.data.file">⬇️</a>&emsp;&emsp; -->
                    <a href="#" @click.prevent="openFileInNewTab(info.data.file)"><em class="fa fa-search"></em></a>&emsp;&emsp;
                    <a href="javascript:void(0);" @click="delFile(info.data.loginId)">❌</a>
                  </span>
                  <span v-else>{{info.data.file}}</span>
               </td>
           </tr>
          </tbody>
        </table>
      </div>
      <PersonalAndVoucher :userBoardList="info.data.userBoardList" />
      <div class="card-body" style="background-color:#fff;">
        <div class="footer">
          <div class="float-right">
              <b-btn v-show="info.data.fileCertifyStatus=='U'" class="btn btn-b btn-outline-info mr-2" variant="outline-primary" @click="acceptOrRejectFile(true, info.data.loginId, info.data.file)" :disabled="info.data.fileCertifyStatus === 'A'">인증 하기</b-btn>
              <b-btn v-show="info.data.fileCertifyStatus=='U'" class="btn btn-b btn-outline-info mr-2" variant="outline-primary" @click="acceptOrRejectFile(false, info.data.loginId, info.data.file)" :disabled="info.data.fileCertifyStatus === 'R'">인증 거절</b-btn>
              <b-btn @click="list()" class="btn btn-b btn-outline-info mr-2" variant="outline-info mr-2">목록</b-btn>
          </div>
        </div>
      </div>
    </div>
    <!-- // 상세 -->

    <loading :active="modalLoading" :is-full-page="true"/>
  </ContentWrapper>    
</template>

<script>
import Vue from 'vue'
import { reactive, ref, computed, onMounted, onUnmounted ,onBeforeMount} from '@vue/composition-api'
import {dataObject, userTypeCd, getUserTypeName, schoolDivCd, getSchoolDivName} from "@/utils/Constants";
import {getUserTeacherList, getUserTeacherDetail, setUserTeacherCertify, setUserTeacherReject, deleteUserTeacherFile} from "@/api/mem/MemberAPI";
import {getUserJoinYn, setYcloudUserTeacherCertify, setYcloudUserTeacherReject, deleteYcloudUserTeacherFile} from "@/api/mem/extMemberAPI";
import {setBooksamUserTeacherCertify, setBooksamUserTeacherReject, deleteBooksamUserTeacherFile} from "@/api/mem/extMemberAPI";
import PersonalAndVoucher from "./component/PersonalAndVoucher";
import moment from 'moment';
import axios from "axios";

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    components: {Loading, PersonalAndVoucher},
    props: {
      loginId: {
        type:String,
        default:null
      }
    },
    setup(props) {
      const modalLoading = ref(false);
      const info = reactive({data:{}, ext:{}});

      // 상세
      const memberStatus = computed(() => {
        if (info.data.delYn === 'Y') {
          return '비활성삭제';
        } else if (info.data.withdrawYn === 'Y') {
          return '탈퇴';
        } else if (info.data.inactiveYn === 'Y') {
          return '비활성';
        } else {
          return '정상';
        }
      });
      const userTypeName = computed(() => {
        return getUserTypeName(info.data.typeCd);
      });
      const schoolDivName = computed(() => {
        return getSchoolDivName(info.data.schlGrdCd);
      })

      const retVals = {
        modalLoading,
        info,
        memberStatus,
        userTypeName,
        schoolDivName,
        ...methods(),
      }
      onMounted(async () => {
        await retVals.detail(props.loginId);
      });

      return retVals;
    }
}

function methods() {

  // 상세
  async function detail(loginId){
    try {
      const result = await getUserTeacherDetail(loginId);
      this.info.data = result.data;

      const joinResult = await getUserJoinYn(loginId);
      this.info.ext = joinResult.data;
    } catch (err) {
      console.log(`err.data:${err.data}`);
      const message = err.data ? (err.data.message || '') : '';
      alert(message ? message : '서버 연결이 안되거나 서버 내부 오류입니다.');
    }
  }

  function list() {
    this.$router.go(-1);
  }

  /**
   * 서류 탭으로 보기.
   */
  async function openFileInNewTab(fileUrl) {
    if (!fileUrl) {
      alert("파일 주소가 없습니다.");
      return;
    }

    try {
      const response = await axios.get(fileUrl, {
        responseType: 'blob',
      });

      const blob = response.data;
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');

      setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
    } catch (error) {
      console.log("파일을 여는 중 오류가 발생했습니다:", error);
      alert("파일을 열 수 없습니다.");
    }
  }

  /**
   * 서류 삭제
   */
  async function delFile(loginId) {
    const confirmStr = '선택한 서류를 삭제하시겠습니까?';
    if (!confirm(confirmStr)) {
      return;
    }

    console.log(`delete File of ${loginId}`);
    const loginIdList = [{"loginId":loginId}];
    
    try {
      const result = await deleteUserTeacherFile(loginIdList);
      console.log(result);
      if (result.data) {
        const loginIdList = [{"userId":loginId}];
        let result = await deleteYcloudUserTeacherFile(loginIdList);
        console.log('deleteYcloudUserTeacherFile result:', result);

        result = await deleteBooksamUserTeacherFile(loginIdList);
        console.log('deleteBooksamUserTeacherFile result:', result);

        alert('서류를 삭제하였습니다.');
        this.detail(loginId);
      } else if (result.message) {
        alert(result.message);
      } else {
        alert('결과값이 없습니다.');
      }
    } catch (err) {
      alert('오류가 발생했습니다.');
    }
  }

  /**
   * 서류 인증 수락/거절
   */
  async function acceptOrRejectFile(accept, loginId, file) {
    const confirmStr = accept ? '선택한 서류를 인증하시겠습니까?' : '선택한 서류를 인증거절하시겠습니까?\n인증거절할 경우 서류도 같이 삭제됩니다.';
    if (!confirm(confirmStr)) {
      return;
    }

    const statusStr = accept ? 'A' : 'R';
    const loginIdList = [{"loginId":loginId, "file":file}];

    try {
      const result = accept ? await setUserTeacherCertify(loginIdList) : 
        await setUserTeacherReject(loginIdList);
      if (result.data) {
        const loginIdList = [{"userId":loginId}];
        let result = accept ? await setYcloudUserTeacherCertify(loginIdList) : 
          await setYcloudUserTeacherReject(loginIdList);
        console.log(accept ? 'setYcloudUserTeacherCertify' : 'setYcloudUserTeacherReject', 'result:', result);

        result = accept ? await setBooksamUserTeacherCertify(loginIdList) : 
          await setBooksamUserTeacherReject(loginIdList);
        console.log(accept ? 'setBooksamUserTeacherCertify' : 'setBooksamUserTeacherReject', 'result:', result);

        alert(accept ? "서류인증이 되었습니다." : "서류 인증거절 되었습니다.");
        this.detail(loginId);
      } else if (result.message) {
        alert(result.message);
      } else {
        alert('결과값이 없습니다.');
      }
    } catch (err) {
      alert('오류가 발생했습니다.');
    }
    
  }

  return {
    detail,
    list,
    openFileInNewTab,
    delFile,
    acceptOrRejectFile,
  }
}
</script>